import {
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Image,
  Tooltip,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import { formatDateAnnouncements} from "../../redux/actions/actions";
import { ReactComponent as ContextMenuIcon } from "../../svg/ContextMenu.svg";
// import { ReactComponent as AnnouncementsIcon } from '../../svg/bullhorn.svg';

export default function IndividualAnnouncementCard({
  title,
  startingDate,
  endingDate,
  startingTime,
  endingTime,
  department,
  image,
  id,
  removeAnnouncement,
  createdDate
}) {
  const history = useHistory();

  const editHandler = () => {
    // dispatch(setEdit(id))
    history.push(`/edit-announcement/${id}`);
  };

  return (
    <Box
      d="flex"
      width="100%"
      bg="white"
      borderRadius="2xl"
      my="1rem"
      py="1rem"
      px="1rem"
      justifyContent={["center", "center", "center", "space-between"]}
      alignItems={["flex-start", "flex-start", "flex-start", "center"]}
      flexDirection={["column", "column", "column", "row"]}
      _hover={{ boxShadow: "xl" }}
      position="relative"
    >
      <Box
        d="flex"
        width={["100%", "100%", "100%", "30%"]}
        flexDir={["column", "column", "column", "row"]}
        justifyContent="flex-start"
        alignItems="center"
        mb={["3rem", "3rem", "3rem", "0"]}
        left="0"
        top="0"
      >
        <Image
          src={image}
          width="50px"
          height="50px"
          fallbackSrc="https://source.unsplash.com/random/800x600"
          objectFit="cover"
          d={["none", "none", "none", "flex"]}
          borderRadius="50%"
          mr="1rem"
        />
        <Tooltip
          label={title}
          fontSize="15px"
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="400"
          color="#ffffff"
          bg="#1B1A1AB2"
          hasArrow
          placement="top"
        >
          <Text
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="700"
            fontSize={["14px", "14px", "16px", "16px"]}
            color="#333333"
            w="25ch"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {title}
          </Text>
        </Tooltip>
      </Box>

      <Box
        d="flex"
        flexDir="column"
        width={["100%", "100%", "100%", "20%"]}
        justifyContent="center"
        alignItems="center"
      >
        <Text
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="400"
          fontSize={["14px", "14px", "16px", "16px"]}
          color="#333333"
        >
          {department ? department : "N/A"}
        </Text>
      </Box>

      <Box
        d="flex"
        flexDir="column"
        width={["100%", "100%", "100%", "15%"]}
        justifyContent="center"
        alignItems="center"
      >
        <Text
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="400"
          fontSize={["14px", "14px", "16px", "16px"]}
          color="#333333"
        >
          {startingDate
            ? `${formatDateAnnouncements(startingDate)} at ${startingTime}`
            : `${formatDateAnnouncements(createdDate)}`}
        </Text>
      </Box>

      <Box
        d="flex"
        flexDir="column"
        width={["100%", "100%", "100%", "15%"]}
        justifyContent="center"
        alignItems="center"
      >
        <Text
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="400"
          fontSize={["14px", "14px", "16px", "16px"]}
          color="#333333"
        >
          {endingDate
            ? `${formatDateAnnouncements(endingDate)} at ${endingTime}`
            : "N/A"}
        </Text>
      </Box>

      <Menu>
        <MenuButton
          as={IconButton}
          mr="1rem"
          border="2px solid rgba(0, 0, 0, 0.1)"
          icon={<ContextMenuIcon />}
          bg="white"
          // width={['100%', '100%', '100%', '15%']}
          _hover={{ bg: "#f8f8f8" }}
          _active={{ bg: "#f8f8f8" }}
          position="static"
          size={["xs", "sm", "sm", "lg"]}
          p={["0.5rem", "0.5rem", "0.5rem", "0.75rem"]}
          width="40px"
          height="40px"
        />
        <MenuList
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="700"
          fontSize="14px"
          color="#00000099"
          minW="0"
          w="150px"
          position="relative"
          zIndex="10"
        >
          <MenuItem onClick={editHandler}>Edit</MenuItem>
          <MenuItem onClick={() => removeAnnouncement(id)}>Delete</MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
}
